import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useKeyboardFocusOnly, useLayoutEffect } from 'bdvp-common/src/hooks';
import { Analytics } from 'bdvp-tracking';

const Bootstrap = ({
    loadApp,
}) => {

    useEffect(() => {

        loadApp();

    }, [loadApp]);

    useKeyboardFocusOnly();

    useLayoutEffect(() => {

        Analytics.modifyTrackAsync();

    }, []);

    return null;

};

Bootstrap.propTypes = {
    loadApp: PropTypes.func.isRequired,
};

export default Bootstrap;
